import { useQuery } from "@tanstack/react-query";
import { useAuth } from "./useAuth";
import { supabase } from "@/integrations/supabase/client";

/**
 * Admins and developers: the team. While Stripe runs on its test key they
 * are the only people who see offers, and the only ones who see test
 * promotions on the site (usePromotions), so a test purchase can be checked
 * end to end. Cached for the session.
 */
export function useIsStaff() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["is_staff", user?.id],
    queryFn: async () => {
      if (!user) return false;
      const [admin, dev] = await Promise.all([
        supabase.rpc("has_role", { _user_id: user.id, _role: "admin" }),
        supabase.rpc("has_role", { _user_id: user.id, _role: "developer" }),
      ]);
      return admin.data === true || dev.data === true;
    },
    enabled: !!user,
    staleTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
